<template>
  <div>
    <div class="box" v-if="!isBigMode">
      <el-tooltip
        class="item"
        effect="dark"
        content="返回"
        placement="top-start"
      >
        <i class="iconfont icon-fanhui1" @click="$router.go(-1)"></i>
      </el-tooltip>
      <route-title></route-title>
      <soft-ware-detail
        :detail="detail"
        v-if="type == '仿真软件'"
      ></soft-ware-detail>
      <div class="detail-box" v-else>
        <div class="detail-left">
          <div class="top-left">
            <p class="detail-name">{{ detail.resourceName }}</p>
            <div class="ev-box">
              <div class="ev-child">
                <div>{{ detail.evaluateScore || 0 }}</div>
                <div>分</div>
                <el-rate v-model="detail.evaluateScore" disabled></el-rate>
              </div>
              <div class="ev-second">
                <i class="iconfont icon-chakan"></i>
                <div class="ev-num">{{ detail.viewCount || 0 }}</div>
                <div class="line"></div>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="收藏"
                  placement="top-start"
                >
                  <img
                    class="sc"
                    style="cursor: pointer"
                    :src="detail.collect ? collect : noCollect"
                    @click="addOptRecord(OPERATIONTYPE[1])"
                    alt=""
                  />
                </el-tooltip>
                <div class="line"></div>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="点赞"
                  placement="top-start"
                >
                  <img
                    class="good"
                    style="cursor: pointer"
                    :src="detail.likes ? good : noGood"
                    @click="addOptRecord(OPERATIONTYPE[0])"
                    alt=""
                  />
                </el-tooltip>
                <div class="line" v-if="!detail.evaluate"></div>
                <el-tooltip
                  class="item"
                  v-if="!detail.evaluate"
                  effect="dark"
                  content="评价"
                  placement="top-start"
                >
                  <img
                    class="xx"
                    style="cursor: pointer"
                    :src="noXx"
                    @click="playScore"
                    alt=""
                  />
                </el-tooltip>
              </div>
            </div>
          </div>
          <div
            class="show-box"
            :style="`height: ${type != 'ppt' ? '47rem' : 'auto'};`"
          >
            <video
              id="audio"
              style="width: 100%; height: 100%"
              v-if="type == '视频'"
              controls
            ></video>
            <div
              v-else-if="type == '文档' && previewUrl"
              style="width: 100%; height: 100%"
            >
              <iframe
                :key="previewUrl"
                :src="$severUrl(previewUrl)"
                style="width: 100%; height: calc(100% - 2.4rem)"
                frameborder="0"
              ></iframe>
              <div class="document-bottom">
                <i class="iconfont icon-quanping" @click="changeMode(true)"></i>
              </div>
            </div>
            <div
              style="width: 100%; height: 100%; background-color: #f0f1f5"
              v-else-if="type == 'ppt' && pptList.length > 0"
            >
              <img
                class="img-ppt"
                v-if="pptList[pptIndex]"
                :src="$severUrl(pptList[pptIndex].filePreviewUrl)"
                alt=""
              />
              <div class="ppt-bottom">
                <p>
                  <i
                    class="iconfont icon-shangyiye"
                    @click="changePpt('last')"
                    style="margin-right: 1rem"
                  ></i
                  >第<span>{{ pptIndex + 1 }}</span
                  >张幻灯片，共<span>{{ pptList.length }}</span
                  >张<i
                    class="iconfont icon-xiayiye"
                    @click="changePpt('next')"
                    style="margin-left: 1rem"
                  ></i>
                </p>
                <i class="iconfont icon-quanping" @click="changeMode(true)"></i>
              </div>
            </div>
            <div v-else-if="['模型'].includes(type)">
              <div
                v-if="suffix == 'fbx'"
                style="height: 100%; width: 100%"
                ref="fbx_model"
              ></div>
              <!-- <model-fbx v-if="suffix == 'fbx'" @on-progress="modelLoading" :lights="lights"
                    :src="previewUrl ? $severUrl(previewUrl) : ''"></model-fbx> -->
              <model-obj
                v-else-if="suffix == 'obj'"
                @on-progress="modelLoading"
                :lights="lights"
                :src="previewUrl ? $severUrl(previewUrl) : ''"
              ></model-obj>
              <model-gltf
                v-else-if="suffix == 'gltf'"
                @on-progress="modelLoading"
                :lights="lights"
                :src="previewUrl ? $severUrl(previewUrl) : ''"
              ></model-gltf>
              <model-stl
                v-else-if="suffix == 'stl'"
                @on-progress="modelLoading"
                :lights="lights"
                :src="previewUrl ? $severUrl(previewUrl) : ''"
              ></model-stl>
              <model-collada
                v-else-if="suffix == 'collada'"
                @on-progress="modelLoading"
                :lights="lights"
                :src="previewUrl ? $severUrl(previewUrl) : ''"
              ></model-collada>
              <model-ply
                v-else-if="suffix == 'ply'"
                @on-progress="modelLoading"
                :lights="lights"
                :src="previewUrl ? $severUrl(previewUrl) : ''"
              ></model-ply>
              <model-three
                v-else-if="suffix == 'three'"
                @on-progress="modelLoading"
                :lights="lights"
                :src="previewUrl ? $severUrl(previewUrl) : ''"
              ></model-three>
            </div>
            <div
              v-else-if="type == '动画'"
              ref="carton"
              style="width: 100%; height: 100%"
            ></div>
            <div
              v-else-if="type == '图片'"
              style="
                width: 100%;
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              <img
                :src="$severUrl(previewUrl)"
                style="max-width: 100%; max-height: 100%"
                alt=""
              />
            </div>
          </div>
          <el-tabs style="margin-top: 2rem" v-model="activeName">
            <el-tab-pane :label="(type || '') + '介绍'" name="video">
              <p style="white-space: var(--lineWrap)" v-if="detail.info">
                {{ detail.info }}
              </p>
              <no-data v-else></no-data>
            </el-tab-pane>
            <el-tab-pane
              :label="`用户评论（${evaluateNumber}）`"
              name="evaluate"
            >
              <evaluate
                @get_total="getTotal"
                ref="evaluate"
                businessType="resource"
              ></evaluate>
            </el-tab-pane>
          </el-tabs>
        </div>
        <div class="detail-right">
          <div class="top-info">
            <div class="ev-title">权属信息</div>
            <div class="info-item" style="margin-top: 3.4rem">
              <div>所属机构：</div>
              <div>{{ detail.institutions }}</div>
            </div>
            <div class="info-item">
              <div>上传人：</div>
              <div>{{ detail.userName }}</div>
            </div>
            <div class="info-item">
              <div>上传时间：</div>
              <div>{{ detail.createTime }}</div>
            </div>
          </div>
          <div class="bottom-info">
            <div class="ev-title">推荐{{ this.type }}</div>
            <div
              v-for="(item, index) in recommendRes"
              style="cursor: pointer"
              @click="toDetail(item)"
              class="bottom-item"
              :key="index"
            >
              <div class="left">
                <img
                  class="img-cover-all cover-img"
                  :src="
                    item.coverImageUrl
                      ? $severUrl(item.coverImageUrl)
                      : $filterResDefault(item.type)
                  "
                  alt=""
                />
              </div>
              <div class="right">
                <div>{{ item.name }}</div>
                <div style="margin-top: 1rem">
                  {{ item.schoolName || "暂无" }}
                </div>
                <div>
                  <div style="margin-right: 2.5rem">
                    {{ item.evaluateScore }}
                  </div>
                  <el-rate disabled v-model="item.evaluateScore"></el-rate>
                </div>
              </div>
            </div>
            <no-data
              style="margin-top: 3rem"
              v-if="recommendRes.length == 0"
            ></no-data>
          </div>
        </div>
      </div>
      <score ref="score" @evaluate_success="evaluateSuccess"></score>
    </div>
    <div class="big-screen" v-else :style="`height:100vh;`">
      <div style="height: 100%">
        <video id="audio" v-if="type == '视频'" controls></video>
        <div v-else-if="type == '文档'" style="width: 100%; height: 100%">
          <iframe
            :key="previewUrl"
            :src="$severUrl(previewUrl)"
            style="width: 100%; height: calc(100% - 4rem)"
            frameborder="0"
          ></iframe>
          <!-- <div class="document-bottom" style="height: 4rem;">
              <i class="iconfont icon-tuichuquanping" style="font-size: 2.5rem;"
                  @click="changeMode(false)"></i>
          </div> -->
        </div>
        <div
          class="big-ppt-box"
          v-else-if="type == 'ppt' && pptList.length > 0"
        >
          <!-- <img :style="`width:calc((100vh - 4rem)*16/9);height:calc(100vh - 4rem);`" v-if="pptList[pptIndex]" :src="$severUrl(pptList[pptIndex].filePreviewUrl)"
              alt=""> -->
          <i
            class="iconfont icon-shangyiyehoutuifanhui-yuankuang big-left"
            @click="changePpt('last')"
          ></i>
          <i
            class="iconfont icon-xiayiyeqianjinchakangengduo-yuankuang big-right"
            @click="changePpt('next')"
          ></i>
          <img
            v-if="pptList[pptIndex]"
            style="width: 100%; height: 100%"
            :src="$severUrl(pptList[pptIndex].filePreviewUrl)"
            alt=""
          />
        </div>
      </div>
    </div>
    <bottom-slider v-if="!isBigMode"></bottom-slider>
  </div>
</template>

<script>
import { QueryResDataDetail } from "@/api/resourceMag";
import { QueryRecommendResData } from "@/api/recommend";
import { AddOptRecord } from "@/api/operation";
import { numberToChinese } from "@/utils/utils";
import { OPERATIONTYPE } from "@/utils/utils";
import { ModelFbx,ModelObj, ModelGltf, ModelStl, ModelCollada, ModelPly, ModelThree } from "vue-3d-model";
import Hls from "hls.js";
import Score from "./Score.vue";
import SoftWareDetail from "./SoftWareDetail.vue";
import Evaluate from "../course/courseDetail/Evaluate.vue";
import NoData from "../common/NoData.vue";
import * as THREE from "three";
import { FBXLoader } from "three/examples/jsm/loaders/FBXLoader.js";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
import { socketMsg } from "@/assets/js/websocket";
import Common from "@/assets/js/common";
import Utils from "@/assets/js/Utils";
export default {
  components: { Score, ModelFbx,ModelObj, ModelGltf, ModelStl, ModelCollada, ModelPly, ModelThree,SoftWareDetail, Evaluate, NoData },
  data() {
    return {
      good: require("../../assets/image/operation/good.png"),
      noGood: require("../../assets/image/operation/no-good.png"),
      collect: require("../../assets/image/operation/sc.png"),
      noCollect: require("../../assets/image/operation/no-sc.png"),
      xx: require("../../assets/image/operation/xx.png"),
      noXx: require("../../assets/image/operation/no-xx.png"),
      ev: require("../../assets/image/operation/pl.png"),
      OPERATIONTYPE,
      scene: null,
      camera: null,
      loader: null,
      fbx: null,
      renderer: null,
      controls: null,
      mixer: null,
      /**评论数量 */
      evaluateNumber: 0,
      type: this.$route.query.type,
      detail: {},
      previewUrl: "",
      activeName: "video",
      pptList: [],
      isBig: false,
      pptIndex: 0,
      /**推荐资源 */
      recommendRes: [],
      lights: [
        {
          type: "HemisphereLight",
          position: { x: 0, y: 1, z: 0 },
          skyColor: 0xffffff,
          // groundColor: 0xFF0000, 此代码为灯光后颜色
          intensity: 1,
        },
        {
          type: "DirectionalLight",
          position: { x: 1, y: 1, z: -10 },
          skyColor: 0xffffff,
          // groundColor: 0xff0000, //此代码为灯光后颜色
          intensity: 0.8,
        },
        {
          type: "DirectionalLight",
          position: { x: 1, y: 1, z: 1 },
          color: 0xffffff,
          intensity: 0.8,
        },
      ],
      /**浏览时间定时器 */
      viewTimer: null,
      /**模型后缀 */
      suffix: "",
    };
  },
  computed: {
    isBigMode() {
      return this.$store.state.menu.isBigMode;
    },
  },
  methods: {
    numberToChinese,
    /**获取评论数量 */
    getTotal(e) {
      this.evaluateNumber = e || 0;
    },
    evaluateSuccess() {
      this.detailResource();
      var evaluate = this.$refs.evaluate;
      if (evaluate) {
        evaluate.list = [];
        evaluate.courseEvaluateList();
      }
    },
    /**全屏模式 */
    openFullscreen() {
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        /* Firefox */
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullscreen) {
        /* Chrome, Safari & Opera */
        document.documentElement.webkitRequestFullscreen();
      } else if (document.documentElement.msRequestFullscreen) {
        /* IE/Edge */
        document.documentElement.msRequestFullscreen();
      }
      let that = this;
      // 监听全屏更改事件
      document.addEventListener("fullscreenchange", function () {
        if (!document.fullscreenElement) {
          that.$store.commit("changeMode", false);
          console.log("已退出全屏模式");
          // 在这里编写退出全屏后的代码
        }
      });
    },
    autoScaleModel(model, targetSize = 2) {
      // 计算模型的包围盒
      const bbox = new THREE.Box3().setFromObject(model);
      const size = bbox.getSize(new THREE.Vector3());

      // 获取最大尺寸
      const maxDim = Math.max(size.x, size.y, size.z);

      // 计算缩放比例
      const scale = targetSize / maxDim;

      // 应用缩放
      model.scale.set(scale, scale, scale);

      console.log(
        `模型尺寸: ${maxDim.toFixed(2)}, 缩放比例: ${scale.toFixed(2)}`
      );
      return scale;
    },
    /**resize fbx模型 */
    windowSize() {
      const fbxModel = this.$refs.fbx_model;
      if (!fbxModel || !this.camera || !this.renderer) return;

      const width = fbxModel.clientWidth;
      const height = fbxModel.clientHeight;

      // 更新相机宽高比
      this.camera.aspect = width / height;
      this.camera.updateProjectionMatrix();

      // 更新渲染器大小
      this.renderer.setSize(width, height);

      // 可选：设置像素比率（针对高清显示屏）
      this.renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    },
    cartonSize() {
      const fbxModel = this.$refs.carton;
      if (!fbxModel || !this.camera || !this.renderer) return;

      const width = fbxModel.clientWidth;
      const height = fbxModel.clientHeight;

      // 更新相机宽高比
      this.camera.aspect = width / height;
      this.camera.updateProjectionMatrix();

      // 更新渲染器大小
      this.renderer.setSize(width, height);

      // 可选：设置像素比率（针对高清显示屏）
      this.renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    },
    /**resize动画 */
    handleFbx() {
      let fbxModel = this.$refs.fbx_model;
      if (!fbxModel) return;
      this.removeCanvas();
      const width = fbxModel.clientWidth;
      const height = fbxModel.clientHeight;

      // 初始化 Three.js 场景
      this.scene = new THREE.Scene();
      this.camera = new THREE.PerspectiveCamera(75, width / height, 0.1, 1000);
      this.renderer = new THREE.WebGLRenderer({ antialias: true }); // 启用抗锯齿
      this.renderer.setSize(width, height);
      fbxModel.appendChild(this.renderer.domElement);
      this.renderer.setClearColor("#ffffff");
      // 设置相机位置和背景
      this.camera.position.set(0, 0, 0.4);
      this.camera.lookAt(0, 0, 0);
      // 添加光源
      const ambientLight = new THREE.AmbientLight(0xffffff, 10); // 调整环境光强度
      const directionalLight = new THREE.DirectionalLight(0xffffff, 1);
      directionalLight.position.set(2, 3, 4);
      directionalLight.castShadow = true;
      this.renderer.shadowMap.enabled = true;
      this.scene.add(ambientLight, directionalLight);

      // 添加相机控制器
      this.controls = new OrbitControls(this.camera, this.renderer.domElement);
      this.controls.enableDamping = true;
      // 加载 FBX 模型
      this.loader = new FBXLoader();
      this.loader.load(
        this.$severUrl(this.previewUrl),
        (fbx) => {
          try {
            this.fbx = fbx;
            this.autoScaleModel(fbx, 0.5);
            // fbx.scale.set(1, 1, 1); // 根据模型大小调整
            this.scene.add(fbx);
            const box = new THREE.Box3().setFromObject(fbx);
            const size = box.getSize(new THREE.Vector3()).length();
            const center = box.getCenter(new THREE.Vector3());

            this.camera.position.copy(center);
            this.camera.position.z += size * 1.2;
            this.camera.lookAt(center);
            fbx.traverse((child) => {
              if (child.isMesh) {
                child.castShadow = true;
                child.material.metalness = 0.58;
                child.material.emissiveMap = child.material.map;
              }
            });

            this.mixer = new THREE.AnimationMixer(fbx);
            if (fbx.animations.length > 0) {
              const idleAction = this.mixer.clipAction(fbx.animations[0]);
              idleAction.play();
            }
            this.animate(); // 启动动画循环
          } catch (error) {
            console.error("动画加载失败:", error);
          }
        },
        undefined,
        (error) => {
          console.error("动画加载错误:", error);
        }
      );
    },
    /** 展示动画 */
    handleCarton() {
      this.removeCanvas(); // 确保旧资源被彻底清理
      let carton = this.$refs.carton;
      if (!carton) return;
      const width = carton.clientWidth;
      const height = carton.clientHeight;

      // 初始化 Three.js 场景
      this.scene = new THREE.Scene();
      this.camera = new THREE.PerspectiveCamera(75, width / height, 0.1, 1000);
      this.renderer = new THREE.WebGLRenderer({ antialias: true }); // 启用抗锯齿
      this.renderer.setSize(width, height);
      carton.appendChild(this.renderer.domElement);

      // 设置相机位置和背景
      this.camera.position.set(0, 0, 0.4);
      this.camera.lookAt(0, 0, 0);
      // this.scene.background = new THREE.Color(0xffffff);
      // 添加地面网格
      const gridHelper = new THREE.GridHelper(20, 20, 0x444444, 0x222222);
      this.scene.add(gridHelper);

      // 添加坐标轴
      const axesHelper = new THREE.AxesHelper(5);
      this.scene.add(axesHelper);
      this.scene.background = new THREE.Color(0x336688);
      // 添加光源
      const ambientLight = new THREE.AmbientLight(0xffffff, 10); // 调整环境光强度
      const directionalLight = new THREE.DirectionalLight(0xffffff, 1);
      directionalLight.position.set(2, 3, 4);
      directionalLight.castShadow = true;
      this.renderer.shadowMap.enabled = true;
      this.scene.add(ambientLight, directionalLight);

      // 添加相机控制器
      this.controls = new OrbitControls(this.camera, this.renderer.domElement);
      this.controls.enableDamping = true;

      // 加载 FBX 模型
      this.loader = new FBXLoader();
      this.loader.load(
        this.$severUrl(this.previewUrl),
        (fbx) => {
          try {
            this.fbx = fbx;
            fbx.scale.set(0.001, 0.001, 0.001); // 根据模型大小调整
            this.scene.add(fbx);

            fbx.traverse((child) => {
              if (child.isMesh) {
                child.castShadow = true;
                child.material.metalness = 0.58;
                child.material.emissiveMap = child.material.map;
              }
            });

            this.mixer = new THREE.AnimationMixer(fbx);
            const idleAction = this.mixer.clipAction(fbx.animations[0]);
            idleAction.play();

            this.animate(); // 启动动画循环
          } catch (error) {
            console.error("动画加载失败:", error);
          }
        },
        undefined,
        (error) => {
          console.error("动画加载错误:", error);
        }
      );
    },

    // 动画循环
    animate() {
      requestAnimationFrame(() => this.animate()); // 节流机制
      if (this.mixer) {
        this.mixer.update(0.016); // 控制帧率
      }
      this.renderer.render(this.scene, this.camera);
    },
    /**推荐资源进入详情 */
    toDetail(item) {
      this.$router.replace({
        query: {
          id: item.id,
          type: this.type,
        },
      });
      if(this.type=='模型'){
        this.removeCanvas('fbx_model');
      }else if(this.type=='动画'){
        this.removeCanvas('carton');
      }
      this.$nextTick(() => {
        this.detail.softwareCover = "";
        this.pptIndex = 0;
        this.evaluateSuccess();
        var params = {
          businessId: this.$route.query.id,
          businessType: "resource",
          optType: OPERATIONTYPE[2],
        };
        AddOptRecord(params);
        window.scrollTo(0, 0);
      });
    },
    /**获取推荐资源 */
    queryRecommendResData() {
      var params = {
        classifyCode: this.detail.classifyCode,
        type: this.type,
        id: this.$route.query.id,
      };
      QueryRecommendResData(params).then((res) => {
        if (res.code == 200) {
          this.recommendRes = res.data;
        }
      });
    },
    /**打分 */
    playScore() {
      var dialog = this.$refs.score;
      if (dialog) {
        dialog.dialogVisible = true;
      }
    },
    /**切换全屏模式 */
    changeMode(value) {
      this.$store.commit("changeMode", value);
      this.openFullscreen();
    },
    modelLoading(xhr) {
      const loading = this.$loading({
        lock: true,
        text: "正在加载模型，请等待！",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
        customClass: "modelLoadingClass",
      });
      if (xhr.loaded == xhr.total) {
        loading.close();
      }
    },
    /**ppt翻页 */
    changePpt(type) {
      if (type == "next") {
        if (this.pptIndex == this.pptList.length - 1) {
          this.$msg({
            showClose: true,
            message: "已经是最后一页啦",
            type: "warning",
          });
          return;
        }
        this.pptIndex++;
      } else {
        if (this.pptIndex == 0) {
          this.$msg({
            showClose: true,
            message: "已经是第一页啦",
            type: "warning",
          });
          return;
        }
        this.pptIndex--;
      }
    },
    /**新增操作记录 */
    addOptRecord(optType) {
      var params = {
        businessId: this.$route.query.id,
        businessType: "resource",
        optType: optType,
      };
      AddOptRecord(params).then((res) => {
        if (res.code == 200) {
          if (this.detail.likes && optType == this.OPERATIONTYPE[0]) {
            this.detail.likes = !this.detail.likes;
          } else if (!this.detail.likes && optType == this.OPERATIONTYPE[0]) {
            this.detail.likes = !this.detail.likes;
          } else if (!this.detail.collect && optType == OPERATIONTYPE[1]) {
            this.detail.collect = !this.detail.collect;
          } else if (this.detail.collect && optType == OPERATIONTYPE[1]) {
            this.detail.collect = !this.detail.collect;
          }
        }
      });
    },
    /**获取资源详情 */
    detailResource() {
      var params = {
        id: this.$route.query.id,
      };
      QueryResDataDetail(params).then((res) => {
        if (res.code == 200) {
          this.detail = res.data;
          var fileArr = res.data.previewFileVOS;
          if (this.type == "视频") {
            var index = fileArr.findIndex((item) => item.orderIndex == -1);
            if (index != -1) {
              fileArr.splice(index, 1);
            }
            for (let item of fileArr) {
              let index = item.filePreviewUrl.indexOf("m3u8");
              if (index != -1) {
                this.previewUrl = item.filePreviewUrl;
                this.playVideo(this.$severUrl(this.previewUrl));
                break;
              }
            }
          } else if (this.type == "文档") {
            this.$nextTick(() => {
              this.previewUrl = fileArr[0].filePreviewUrl;
            });
          } else if (this.type == "ppt") {
            var indexPpt = fileArr.findIndex((item) => item.orderIndex == -1);
            if (indexPpt != -1) {
              fileArr.splice(indexPpt, 1);
            }
            this.pptList = fileArr;
          } else if (["动画", "模型"].includes(this.type)) {
            this.previewUrl = fileArr[0].filePreviewUrl;
            let arr = this.previewUrl.split(".");
            this.suffix = arr[arr.length - 1].toLowerCase();
            if (this.type == "动画") {
              this.$nextTick(() => {
                !this.renderer && this.handleCarton();
              });
            } else if (this.suffix == "fbx" && this.type == "模型") {
              this.$nextTick(() => {
                this.handleFbx();
                window.addEventListener("resize", this.windowSize);
              });
            }
          } else if (this.type == "图片") {
            this.previewUrl = fileArr[0].filePreviewUrl;
          }
          this.queryRecommendResData();
        }
      });
    },
    /**移除画布 */
    removeCanvas(ref='carton') {
      const dom = this.$refs[ref];
      const canvas = this.renderer ? this.renderer.domElement : null;
      if (dom && canvas) {
        dom.removeChild(canvas);
      }
    },
    /**m3u8视频播放 */
    playVideo(previewUrl) {
      this.$nextTick(() => {
        const audio = document.getElementById("audio");
        const hls = new Hls();
        if (Hls.isSupported()) {
          hls.loadSource(previewUrl);
          hls.attachMedia(audio);
          hls.on(Hls.Events.MANIFEST_PARSED, function () {
            audio.play();
          });
        } else if (audio.canPlayType("application/vnd.apple.mpegurl")) {
          audio.src = previewUrl;
          audio.addEventListener("canplay", function () {
            audio.play();
          });
        } else {
          console.error("HLS is not supported in this browser");
        }
      });
    },
    /**统计浏览时间 */
    sendViewTimer() {
      var params = {
        businessId: this.$route.query.id,
        businessType: "resource",
        optType: OPERATIONTYPE[2],
      };
      AddOptRecord(params).then((res) => {
        if (res.code == 200) {
          if (!Common.getCookie("token")) return;
          this.viewTimer = setInterval(() => {
            socketMsg({ id: res.data }, true, "file_study_timing", ["zdzx-sp"]);
          }, 5000);
        }
      });
    },
    /**取消监听 */
    delMonitor() {
      this.viewTimer && clearInterval(this.viewTimer);
    },
  },
  mounted() {
    this.detailResource();
    this.sendViewTimer();
    Utils.$on("user-login", this.sendViewTimer);
    Utils.$on("sys_logout", this.delMonitor);
    if (this.type == "动画") {
      window.addEventListener("resize", this.cartonSize);
    }
  },
  destroyed() {
    this.viewTimer && clearInterval(this.viewTimer);
    Utils.$off("user-login", this.sendViewTimer);
    Utils.$off("sys_logout", this.delMonitor);
    this.$store.commit("changeMode", false);
    window.removeEventListener("resize", this.cartonSize);
    window.removeEventListener("resize", this.windowSize);
  },
};
</script>

<style lang="less" scoped>
.box {
  padding: 13.8rem var(--padding) 0 var(--padding);
  color: #000000;
  position: relative;
}

.detail-box {
  display: flex;
  margin-bottom: 3rem;

  .detail-name {
    color: #000000;
    font-size: 2.8rem;
    font-weight: 700;
    margin-top: 4.6rem;
  }
}

.detail-left {
  width: 83rem;
}

.ev-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 2rem;

  & > :nth-child(1) {
    display: flex;
    align-items: flex-end;
    color: #3f3f3f;

    & > :nth-child(1) {
      font-size: 3rem;
      margin-bottom: -0.5rem;
    }

    & > :nth-child(3) {
      margin-left: 3px;
    }

    /deep/.el-rate {
      line-height: 1.5;
    }
  }
}

.ev-second {
  display: flex;
  align-items: center;
  margin-top: 16px;

  & > :nth-child(1) {
    cursor: default;
  }

  .ev-num {
    color: #8590b3;
    font-size: 16px;
    margin-left: 5px;
  }

  .icon-shoucang2 {
    font-size: 1.8rem;
  }

  .line {
    width: 1px;
    height: 16px;
    background-color: #dcdfe6;
    margin: 0 1rem;
  }

  i {
    font-size: 2.5rem;
    color: #99a1be;
    cursor: pointer;
  }

  .icon-dianzan2 {
    font-size: 2rem;
  }

  .icon-qianbi {
    font-size: 1.8rem;
  }
}

.show-box {
  margin-top: 2.5rem;

  & > :nth-child(1) {
    width: 100%;
    height: 100%;
  }
}

.ev-title {
  color: #151c34;
  font-size: 1.8rem;
}

.detail-right {
  margin-left: 9rem;
  flex: 1;
}

.info-item {
  display: flex;
  font-size: 14px;
  margin-top: 1.5rem;

  & > :nth-child(1) {
    color: #8590b3;
  }

  & > :nth-child(2) {
    color: #334681;
  }
}

.bottom-info {
  margin-top: 6rem;

  .bottom-item {
    display: flex;
    margin-top: 3rem;

    .left {
      width: 14rem;
      aspect-ratio: var(--aspectRatio);
    }

    .right {
      margin-left: 1.5rem;

      & > :nth-child(1) {
        color: #334681;
        font-size: 16px;
      }

      & > :nth-child(2) {
        color: #8590b3;
        font-size: 14px;
      }

      & > :nth-child(3) {
        display: flex;
        margin-top: 1.5rem;
        color: #ffe769;
        font-weight: 700;
      }
    }
  }
}

.document-bottom {
  height: 2.4rem;
  background-color: #444444;
  color: #ffffff;
  display: flex;
  font-size: 12px;
  display: flex;
  justify-content: flex-end;
  align-items: center;

  & > :nth-child(n) {
    margin-right: 3rem;
    cursor: pointer;
  }
}

.ppt-bottom {
  height: 2.4rem;
  background-color: #444444;
  color: #ffffff;
  display: flex;
  justify-content: center;
  font-size: 12px;
  align-items: center;
  position: relative;

  & > :nth-child(1) {
    display: flex;
    align-items: center;
  }

  i {
    cursor: pointer;
  }

  & > :nth-child(2) {
    position: absolute;
    top: calc(50% - 0.8rem);
    right: 3rem;
  }
}

.img-ppt {
  // width: 83rem;
  // height: calc(83rem*9/16);
  width: 100%;
  height: auto;
}

.collect-active {
  color: #f7ba2a !important;
}

.up-active {
  color: #ff4e00 !important;
}

.icon-fanhui1 {
  position: absolute;
  top: 14rem;
  left: 33rem;
  color: #000000;
  font-size: 2rem;
  cursor: pointer;
}

.big-screen {
  position: relative;
}

.big-ppt-box {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.big-left {
  position: absolute;
  top: 50%;
  left: 3rem;
  transform: translateY(-50%);
  z-index: 9999;
  font-size: 5rem;
  color: rgba(0, 0, 0, 0.6);
  cursor: pointer;
}

.big-right {
  position: absolute;
  top: 50%;
  right: 3rem;
  transform: translateY(-50%);
  z-index: 9999;
  font-size: 5rem;
  color: rgba(0, 0, 0, 0.6);
  cursor: pointer;
}

.icon-quanping {
  font-size: 14px;
}
.cover-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
@media screen and (max-width: 750px) {
  .detail-box {
    display: block !important;
    & > :nth-child(n) {
      width: 100%;
    }
    .detail-right {
      margin-left: 0;
    }
  }
  .icon-fanhui1 {
    left: 20rem;
  }
  .top-info{
    margin-top: 2rem;
  }
}
</style>